export default {
    h5: {
        checkCertification:
            "/gateway/huilianCust/certificationcs/checkCertification", //校验是否实名
    },
    wechat: {
        checkCertification:
            "/gateway/huilianCust/certificationcs/checkCertification", //校验是否实名
    },
};



// WEBPACK FOOTER //
// ./src/authCertificateCompact/ACGuide/api.js